/* eslint-disable */

import { AddOn } from './AddOn';
//import * as wording from '../../../common/js/wording'
import { AddOnType } from '../FbbEnum';
import * as log from '../../../common/js/appLogger';

/*

*/
export class AddOnAppleiPad extends AddOn {
	protected isBasePlanSelected: boolean = false;
	protected baseVasCode: String = 'IPAD';

	constructor() {
		super();
		this.key = 'AddOnAppleiPad';

		this.boxIconEn = '';
		this.boxIconZh = '';
		this.boxNameEn = 'Apple iPad Series';
		this.boxNameZh = 'Apple iPad Series';
		this.boxAmount = 1200; // per month
		this.discountAmount = -1; // 3080
		this.hasRedCounter = false;

		this.type = AddOnType.SINGLE;
	}

	public getBaseVasCode(): String {
		return this.baseVasCode || '';
	}

	public isAddOnSelected(): boolean {
		return this.boxCount > 0;
	}

	//=================================================================================
	/** no overwrite AddOn one 
    public getData() : any {
        //var data = super.getData()
        return data
    }
    public parse(data: any) {
        //super.parse(data)
    }
    */
	//=================================================================================

	public getPlanVasCode(): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			vasCode = this.getBaseVasCode() + '';
			return vasCode;
		} else {
			return '';
		}
	}
}
